export const environment = {
  baseUrl: 'https://app-api.dev.leuprologix.com',
  envUrl: 'https://dev.leuprologix.com',
  production: false,
};
